module.exports = __webpack_public_path__ + "img/5.130587f1.png";